import script from "./PagoFactura.vue?vue&type=script&setup=true&lang=js"
export * from "./PagoFactura.vue?vue&type=script&setup=true&lang=js"

import "./PagoFactura.vue?vue&type=style&index=0&id=153fc3ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-153fc3ca"]])

export default __exports__